// Configuration for the application
export const config = {
  s3: {
    REGION: import.meta.env.VITE_S3_REGION || "ap-south-1",
    BUCKET: import.meta.env.VITE_S3_BUCKET || "instavc-uploads",
    PROFILEBUCKET: import.meta.env.VITE_S3_PROFILE_BUCKET || "instavcprofileimages",
    INSTAVCRECORDINGSBUCKET: import.meta.env.VITE_S3_RECORDINGS_BUCKET || "instavcrecordings",
    CONTENTBUCKET: import.meta.env.VITE_S3_CONTENT_BUCKET || "instavc-content",
    folder: "content",
    chatfolder: "chat",
    webinarfolder: "webinar",
  },
  apiGateway: JSON.parse(import.meta.env.VITE_apiGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiDomainGateway: JSON.parse(import.meta.env.VITE_apiDomainGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiMcuGateway: JSON.parse(import.meta.env.VITE_apiMcuGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiUserGateway: JSON.parse(import.meta.env.VITE_apiUserGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiClassCreateGateway: JSON.parse(import.meta.env.VITE_apiClassCreateGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiPlanGateway: JSON.parse(import.meta.env.VITE_apiPlanGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiCouponGateway: JSON.parse(import.meta.env.VITE_apiCouponGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiTransactionGateway: JSON.parse(import.meta.env.VITE_apiTransactionGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiReferralGateway: JSON.parse(import.meta.env.VITE_apiReferralGateway || '{"REGION":"ap-south-1","URL":""}'),
  apiRecordingGateway: JSON.parse(import.meta.env.VITE_apiRecordingGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apimcuRecordingGateway: JSON.parse(import.meta.env.VITE_apimcuRecordingGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiContentGateway: JSON.parse(import.meta.env.VITE_apiContentGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiScheduleGateway: JSON.parse(import.meta.env.VITE_apiScheduleGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiAddressGateway: JSON.parse(import.meta.env.VITE_apiAddressGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiMultipartUploadGateway: JSON.parse(import.meta.env.VITE_apiMultipartUploadGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiMeetingGateway: JSON.parse(import.meta.env.VITE_apiMeetingGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiMailGateway: JSON.parse(import.meta.env.VITE_apiMailGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiBroadcastGateway: JSON.parse(import.meta.env.VITE_apiBroadcastGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiTestGateway: JSON.parse(import.meta.env.VITE_apiTestGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiDocumentShareGateway: JSON.parse(import.meta.env.VITE_apiDocumentShareGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiChatGateway: JSON.parse(import.meta.env.VITE_apiChatGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  apiAdminGateway: JSON.parse(import.meta.env.VITE_apiAdminGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  invcScheduleAPI: JSON.parse(import.meta.env.VITE_invcScheduleAPI || '{"REGION":"ap-southeast-1","URL":""}'),
  invcEmailAPI: JSON.parse(import.meta.env.VITE_invcEmailAPI || '{"REGION":"ap-southeast-1","URL":""}'),
  invcLicenseAPI: JSON.parse(import.meta.env.VITE_invcLicenseAPI || '{"REGION":"ap-south-1","URL":""}'),
  ipIndiaGateway: JSON.parse(import.meta.env.VITE_ipIndiaGateway || '{"REGION":"ap-southeast-1","URL":""}'),
  inclassChatAPI: JSON.parse(import.meta.env.VITE_inclassChatAPI || '{"REGION":"ap-south-1","URL":""}'),
  inclassMcuAPI: JSON.parse(import.meta.env.VITE_inclassMcuAPI || '{"REGION":"ap-southeast-1","URL":""}'),
  inclassReportsAPI: JSON.parse(import.meta.env.VITE_inclassReportsAPI || '{"REGION":"ap-south-1","URL":""}'),
  inclassAssessmentsAPI: JSON.parse(import.meta.env.VITE_inclassAssessmentsAPI || '{"REGION":"ap-south-1","URL":""}'),
  inaffiliateUserAPI: JSON.parse(import.meta.env.VITE_inaffiliateUserAPI || '{"REGION":"ap-south-1","URL":""}'),
  cognito: JSON.parse(import.meta.env.VITE_cognito || '{"REGION":"ap-southeast-1","USER_POOL_ID":"","APP_CLIENT_ID":"","IDENTITY_POOL_ID":"","INVC_IDENTITY_POOL_ID":""}'),
  isOffline: false,
  AppUse: 2, // 1 - InstaVC(Intl), 2-InVC (MSoup), 3 - (Jitsi)
  lang: "en",
  defaultSubdomain: ["app", "test"],
  enableBreakout: true,
  mcuURLifOffline: "wss://mcu.peoplelinkvc.com:20072",
  iot: {
    awsIotHost: import.meta.env.VITE_AWS_IOT_HOST || "",
    logLevel: 1,
    mqttDebugLevel: 1,
  },
  captchasitekey: import.meta.env.VITE_CAPTCHA_SITE_KEY || "",
  invccaptchasitekey: import.meta.env.VITE_INVC_CAPTCHA_SITE_KEY || "",
  sampleparticipantUrl: "https://instavc-content.s3-ap-southeast-1.amazonaws.com/sampleparticipants.xlsx",
  isClass: false,
  affiliate: {
    productCode: "INCLASS",
    baseUrl: "https://api.inaffiliate.vc/users",
  },
};

export const workspace = {
  peer: {
    url: import.meta.env.VITE_PEER_URL || "https://awspeer.instavc.com",
  },
};